import { useTransition, animated, easings } from '@react-spring/web';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import styles from '../../styles/components/icons/conspi-icon.module.css';

import conspi1 from '../../assets/img/conspi/1.png';
import conspi2 from '../../assets/img/conspi/2.png';
import conspi3 from '../../assets/img/conspi/3.png';

const images = [conspi1, conspi2, conspi3];

interface ConspiIconProps {
    className?: string;
    duration?: number;
}

function ConspiIcon({ className = null, duration = 2000 }: ConspiIconProps) {
    const [currentImage, setCurrentImage] = useState(images[0]);
    const transitions = useTransition([currentImage], {
        from: { opacity: 0, scale: 0.8 },
        enter: { opacity: 1, scale: 1 },
        leave: { opacity: 0, scale: 0.5 },
        keys: (item) => item,
        config: {
            easing: easings.easeInBounce,
        },
    });

    const transitionsCircle = useTransition([currentImage], {
        from: { opacity: 0, scale: 0.5 },
        enter: { opacity: 1, scale: 1 },
        leave: { opacity: 0, scale: 0.2 },
        keys: (item) => item,
        config: {
            easing: easings.easeInElastic,
        },
    });

    useEffect(() => {
        const timeout = setTimeout(() => {
            setCurrentImage((prevImage) => {
                const currentIndex = images.indexOf(prevImage);
                const nextIndex = (currentIndex + 1) % images.length;
                return images[nextIndex];
            });
        }, duration);
        return () => clearTimeout(timeout);
    }, [duration, currentImage]);
    return (
        <div className={classNames([styles.container, className])}>
            {transitions((style, item) => (
                <animated.img src={item} className={styles.image} alt={item} style={style} />
            ))}
            {transitionsCircle((style, item) => (
                <animated.div className={styles.circle} style={style} />
            ))}
        </div>
    );
}

export default ConspiIcon;
